/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Rehab_TitleInputs */

const en_for_whom_rehab_title = /** @type {(inputs: For_Whom_Rehab_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get back in shape, without rushing.`)
};

const pl_for_whom_rehab_title = /** @type {(inputs: For_Whom_Rehab_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wróć do formy bez pośpiechu.`)
};

/**
* | output |
* | --- |
* | "Get back in shape, without rushing." |
*
* @param {For_Whom_Rehab_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_rehab_title = /** @type {((inputs?: For_Whom_Rehab_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Rehab_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_rehab_title(inputs)
	return en_for_whom_rehab_title(inputs)
});